import { AssignPermissionOptions } from '@/common/static_data';

import { PermissionValue } from './types';
import { FeaturePermissionMatrix } from '@/apis/types';

export const ALL_SHIPMENT_STATUSES: string[] = [
  'Awaiting pickup',
  'Pending',
  'In transit',
  'Delivery exception',
  'Delivered',
  'Not found',
];

const BASE_ROLE_NAMES = ['admin', 'member', 'viewer'];
export const isBaseLocked = (roleName: string): boolean =>
  BASE_ROLE_NAMES.includes(String(roleName || '').toLowerCase());

type Option = { value: PermissionValue; label: string };

export const optionsForSection = (featureName: string): Option[] => {
  const lc = String(featureName || '').toLowerCase();
  if (lc.includes('teams')) {
    return AssignPermissionOptions.filter(
      (i: Option) => i.value === 'VIEW' || i.value === 'NO_ACCESS'
    );
  }
  if (lc.includes('settings: ai workflow')) {
    return AssignPermissionOptions.filter(
      (i: Option) => i.value === 'VIEW' || i.value === 'NO_ACCESS'
    );
  }
  if (lc.includes('notifications')) {
    return AssignPermissionOptions.filter(
      (i: Option) => i.value !== 'EDIT_CONTACTS_ONLY'
    );
  }
  if (lc.includes('locations')) {
    return AssignPermissionOptions.filter(
      (i: Option) => i.value !== 'Create_self'
    );
  }
  const excludedValues = ['Create_self', 'EDIT_CONTACTS_ONLY'];

  return (AssignPermissionOptions as Option[]).filter(
    (option) => !excludedValues.includes(option.value)
  );
};

export const optionsForSubFeature = (featureName: string): Option[] => {
  const lc = String(featureName || '').toLowerCase();
  if (
    ['shipment vitals', 'chatbot', "who's viewing", 'shipment status'].includes(
      lc
    )
  ) {
    return (AssignPermissionOptions as Option[]).filter(
      (i) => i.value === 'VIEW' || i.value === 'NO_ACCESS'
    );
  }
  if (['ai call and email transcripts', 'ai call recordings'].includes(lc)) {
    return (AssignPermissionOptions as Option[]).filter(
      (i) => i.value === 'EDIT' || i.value === 'NO_ACCESS'
    );
  }
  if (['publish gxp report', 'tor rules', 'gxp settings'].includes(lc)) {
    const excludedVals = ['Create_self', 'EDIT_CONTACTS_ONLY'];
    return (AssignPermissionOptions as Option[]).filter(
      (i) => !excludedVals.includes(i.value)
    );
  }

  const excludedValues = ['CREATE', 'Create_self', 'EDIT_CONTACTS_ONLY'];

  return (AssignPermissionOptions as Option[]).filter(
    (i) => !excludedValues.includes(i.value)
  );
};

export const getBackground = (
  roleName: string,
  isNoAccess: boolean,
  isBaseLocked: (roleName: string) => boolean,
  permission: FeaturePermissionMatrix
): string => {
  if (!permission.is_create && !permission.is_update) {
    return isNoAccess ? 'var(--gray-300)' : 'var(--surface-container)';
  }
  if (!isBaseLocked(roleName)) {
    return isNoAccess ? 'var(--gray-300)' : 'var(--light-gray)';
  }
  return isNoAccess ? 'var(--gray-300)' : 'var(--surface-container)';
};
